import React from 'react';

//controls
import AvatarCircle from './AvatarCircleReclamo';
//icon
import { Img1,Img2,Img3 } from '../../svg/reclamo';

import { contentTitlesClaim } from '../../utils/constanst';

const IconProgressBar = ({indexProgress}) => {

    const widthIcon = 75;
    const width = 100 * indexProgress;

    const arrIcons = [
        <Img1 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img2 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img3 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>
    ]



    return (
        <div className="sg-iconbar_nr">
            {arrIcons.map((icon, index) => 
                <AvatarCircle key={index} index={index} indexProgress={indexProgress} width={widthIcon}>
                    {icon}
                </AvatarCircle>
               
            )}
            
        </div>
    );
}

export default IconProgressBar;
